import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LoadingSpinner } from '../../components/ui/LoadingSpinner';

export function MagicLinkCallbackPage() {
  const navigate = useNavigate();
  const { ready, session } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!ready) return;

    // Supabase automatically handles the magic link verification
    // If we have a session, the auth was successful
    if (session) {
      // Redirect to home page
      setTimeout(() => navigate('/'), 1000);
    } else {
      setError('Authentication failed or link expired. Please try again.');
      setTimeout(() => navigate('/login'), 3000);
    }
  }, [ready, session, navigate]);

  return (
    <div className="min-h-screen bg-warm-50 dark:bg-gray-950 flex flex-col items-center justify-center px-6">
      {error ? (
        <div className="text-center">
          <div className="text-5xl mb-4">❌</div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">
            Authentication Failed
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-sm">
            {error}
          </p>
          <button
            onClick={() => navigate('/login')}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Back to Login
          </button>
        </div>
      ) : (
        <div className="text-center">
          <LoadingSpinner size="lg" />
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-6">
            Signing you in...
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Just a moment while we verify your magic link.
          </p>
        </div>
      )}
    </div>
  );
}
